// extracted by mini-css-extract-plugin
export default {"content":"ChangePasswordView_content__XPfXG","panel":"ChangePasswordView_panel__zs-HF","fadeInDown":"ChangePasswordView_fadeInDown__BrLHV"};